const state = {
  lastAnnonceMatchAttemptId: null,
  currentUserCountryCode: 'FR',
  identityToSubmit: null,
}

const getters = {
  lastAnnonceMatchAttemptId: (state) => state.lastAnnonceMatchAttemptId,
  currentUserCountryCode: (state) => state.currentUserCountryCode,
  identityToSubmit: (state) => state.identityToSubmit,
}

const actions = {

  setLastAnnonceMatchAttemptId ({commit}, id) {
    commit('lastAnnonceMatchAttemptId', id)
  },

  setCurrentUserCountryCode ({commit}, countryCode) {
    commit('currentUserCountryCode', countryCode)
  },

  setIdentityToSubmit ({commit}, identityToSubmit) {
    commit('identityToSubmit', identityToSubmit)
  }

}

const mutations = {

  setLastAnnonceMatchAttemptId (state, id) {
    state.lastAnnonceMatchAttemptId = id
  },

  setCurrentUserCountryCode (state, countryCode) {
    state.currentUserCountryCode = countryCode
  },

  setIdentityToSubmit (state, identityToSubmit) {
    state.identityToSubmit = identityToSubmit
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/storeUtils.js